import React from 'react'

import { TFunction } from 'i18next'

import { Lock } from '@surglogs-app/icons'
import { List } from '@surglogs-app/ui'

import { MfaMethodItem } from './MfaMethodItem'

interface MfaMethodListProps {
  mfaEnabled: boolean
  showSetup?: boolean
  onMfaRevoke?: () => void
  onMfaSetup?: () => void
  isLoading?: boolean
  t: TFunction<any>
}

export const MfaMethodList = ({
  mfaEnabled,
  showSetup = false,
  isLoading = false,
  onMfaRevoke,
  onMfaSetup,
  t,
}: MfaMethodListProps) => {
  return (
    <List {...{ mt: 'md' }}>
      <MfaMethodItem
        {...{
          label: t('mfaMethods.authenticatorApp.title'),
          description: t('mfaMethods.authenticatorApp.description'),
          icon: Lock,
          isEnabled: mfaEnabled,
          showSetup,
          setupTitle: t('mfaMethods.authenticatorApp.setupTitle'),
          onRevoke: onMfaRevoke,
          onSetup: onMfaSetup,
          isLoading,
          t,
        }}
      />
    </List>
  )
}
